import { createContext, useContext, useState } from "react";

// Create Context
const TabContext = createContext();

// Context Provider Component
export function TabProvider({ children }) {
  const [currentActiveTab, setCurrentActiveTab] = useState("earnTab");

  return (
    <TabContext.Provider value={{ currentActiveTab, setCurrentActiveTab }}>
      {children}
    </TabContext.Provider>
  );
}

// Custom Hook to use the Context
export function useTab() {
  return useContext(TabContext);
}
